module.exports = __webpack_public_path__ + "img/Zhomebie06.168fc96a.png";